<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" sm="4" md="4" lg="3">
        <v-select
          class="ml-2 mt-2 fiscal-terms-selection"
          :disabled="loading"
          v-model="selectedFiscalTerms"
          :items="fiscalTermsList"
          @change="changeFiscalTerm"
          :menu-props="{ bottom: true, offsetY: true }"
          outlined
          item-text="Project(Name)"
          :no-data-text="$t('noData')"
          item-value="Project(Code)"
          :label="!Array.isArray(selectedFiscalTerms) ? $t('business.lblFiscalTerms') : $t('lblPleaseSelect')"
          return-object
          dense
          filled
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="3">
        <v-select
          class="ml-2 mt-2 comparedTo-selection"
          :disabled="loading"
          v-model="selectedComparedTo"
          :items="fiscalTermsList"
          @change="changeComparedTo"
          :menu-props="{ bottom: true, offsetY: true }"
          outlined
          item-text="Project(Name)"
          :no-data-text="$t('noData')"
          item-value="Project(Code)"
          :label="!Array.isArray(selectedComparedTo) ? $t('business.lblComparedTo') : $t('lblPleaseSelect')"
          return-object
          dense
          filled
        ></v-select>
      </v-col>
      <v-col cols="4" sm="4" md="4">
        <a-menu
          v-model="isOpen"
          bottom
          end
          :close-on-content-click="false"
          offset-y
          max-height="300"
          :z-index="5"
          :disabled="loading"
        >
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom :disabled="isOpen">
              <template v-slot:activator="{ on: tooltip }">
                <a-btn
                  :width="240"
                  color="primaryDark"
                  v-bind="attrs"
                  v-on="{ ...menu, ...tooltip }"
                  class="mt-2 ml-2"
                  :disabled="loading"
                >
                  <span
                    style="
                      width: 162px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    "
                  >
                    {{ label }}
                  </span>
                  <v-icon size="22" v-if="!isOpen">mdi-chevron-down</v-icon>
                  <v-icon size="22" v-else>mdi-chevron-up</v-icon>
                </a-btn>
              </template>
              <span>{{ $t("business.lblSelectCompanies") }}</span>
            </v-tooltip>
          </template>
          <v-list dense style="padding: 0" :min-width="240">
            <v-list-item v-if="companyList.length == 0">
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t("noData") }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item-group v-else v-model="selectedCompanies" multiple>
              <v-list-item
                v-for="(item, index) in companyList"
                :key="index"
                :value="item"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action class="mr-2">
                    <v-checkbox
                      dense
                      :input-value="active"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item["Company(Name)"] }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </a-menu>
      </v-col>
    </v-row>
    <v-card elevation="0" class="ma-0 pa-2">
      <a-data-table
        v-if="false"
        :headers="headers"
        :items.sync="paginatedResult"
        :page="page"
        :height="gridHeight"
        :items-per-page="paginatedResult.length"
        dense
        class="elevation-1 timer-table"
        :no-data-text="$t('noData')"
        :no-results-text="$t('emptySearchRecords')"
        sort-by="companyName"
        hide-default-footer
        fixed-header
      >
        <template v-slot:item="{ item }">
          <tr :id="`row-${item.index}`">
            <!-- Company details -->
            <td
              v-if="!item.isRowSpan"
              :rowspan="getRowspan(item)"
              style="
                word-break: break-word;
                vertical-align: top;
                border-right: thin solid rgba(0, 0, 0, 0.12);
                padding-top: 5px !important;
              "
            >
              {{ item.companyCode }}<br />
              {{ item.companyName }}
            </td>
            <!-- Project details -->
            <td
              v-if="!item.isRowSpan"
              :rowspan="getRowspan(item)"
              class="top-align border-right"
              style="word-break: break-word"
            >
              {{ item.projectCode }}<br />{{ item.projectName }}
            </td>
            <td>{{ item.accountName }}</td>
            <td>{{ item.accountCode }}</td>
            <td>
              {{ item.accountSortNumber }}
            </td>
            <td>
              {{ item.parentBasicAmount }}
            </td>
            <td>{{ item.amountInPreviousTerm }}</td>
            <td>{{ item.previousTermDifference }}</td>
            <td>{{ item.previousTermRatio }}</td>
          </tr>
        </template>

        <!-- Custom Pagination -->
        <template v-slot:footer>
          <div class="v-data-footer" style="margin: 0">
            <!-- Items per page selector -->
            <div class="v-data-footer__select">
              Rows per page:
              <v-select
                v-model="itemsPerPage"
                :items="[1, 5, 10, 25, 50]"
                style="max-width: 60px; margin: 20px 0 6px 34px"
                dense
                @change="changeItemsPerPage"
              />
            </div>

            <!-- Displaying item count -->
            <div class="v-data-footer__pagination">
              <span
                >{{ startItem }} - {{ endItem }} of
                {{ companyNames.length }}</span
              >
            </div>

            <!-- Custom Pagination Controls -->
            <div class="d-flex justify-center">
              <v-btn :disabled="page === 1" @click="prevPage" icon>
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn :disabled="page === totalPages" @click="nextPage" icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </div>
        </template>
      </a-data-table>
      <v-skeleton-loader
        v-if="loading"
        type="table-thead, table-tbody"
      ></v-skeleton-loader>
      <LCAGridView v-else :lcaData="lcaRes" :key="render"></LCAGridView>
      <v-row
        no-gutters
        class="mt-2 d-flex justify-space-between"
        v-if="updateBusinessPerformancePermission"
        :disabled="loading"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              v-if="updateBusinessPerformancePermission"
              :disabled="loading"
              small
              text
              color="primary"
              @click="selectLCAReport()"
            >
              {{ $t("business.btnUploadLCAReportByCompany") }}
            </a-btn>
          </template>
          <span> {{ $t("business.btnUploadLCAReportByCompany") }} </span>
        </v-tooltip>
        <v-tooltip bottom v-if="showDataManagementBtn">
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              v-if="showDataManagementBtn"
              :disabled="loading"
              small
              text
              color="#888"
              @click="isDataManagementDialogOpen = true"
            >
              <v-icon>mdi-delete</v-icon>
            </a-btn>
          </template>
          <span> {{ $t("btnDelete") }} </span>
        </v-tooltip>
      </v-row>

      <a-dialog v-model="uploadDialog" persistent scrollable max-width="700px">
        <v-card flat>
          <v-toolbar color="#CFDDE6" flat dark height="48px">
            <a-btn color="darkCharcoal" icon large>
              <v-icon>mdi-cloud-upload</v-icon>
            </a-btn>
            <span>{{ $t("business.lblUploadLCAReportByCompany") }}</span>
            <v-spacer></v-spacer>
            <CloseIcon @click="closeUploadFiles" />
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" style="padding: 0 !important">
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <upload-file
                      v-if="uploadDialog"
                      :files="uploadingFiles"
                      :icons="fileIcons"
                      :clearList="uploadDialog"
                      v-on:add-files="addUploadingFiles"
                      v-on:remove-file="removeUploadingFile"
                      :accept="file_accept"
                      :hideDetails="false"
                      :chunkUpload="false"
                    ></upload-file>
                  </v-form>
                </v-col>
                <v-col cols="12" style="padding: 0px 10px !important">
                 {{ $t("business.lblUploadReportNotice") }}
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <span
              v-if="errorCount > 0"
              class="error--text"
              style="
                font-family: 'Noto Sans JP';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 18px;
              "
              ><small>{{
                $t("documents.invalidFileMsg", { count: errorCount })
              }}</small></span
            >
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a-btn
                  small
                  v-bind="attrs"
                  :disabled="
                    !valid ||
                    errorCount > 0 ||
                    !Boolean(uploadingFiles.length) ||
                    loading
                  "
                  v-on="on"
                  :class="uploadingFiles.length ? 'primaryDark' : 'secondary'"
                  @click="uploadLCAReport"
                  >{{ $t("documents.upload") }}</a-btn
                >
              </template>
              <span>{{ $t("documents.upload") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="secondary ml-2"
                  @click="closeUploadFiles"
                  :disabled="loading"
                  >{{ $t("btnClose") }}</a-btn
                >
              </template>
              <span>{{ $t("btnClose") }}</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </a-dialog>
      <data-management-dialog
        :isOpen="isDataManagementDialogOpen"
        :companyTabCompanies="fiscalTermsList"
        @update:isOpen="updateDataManagementDialog"
        @update:loading="updateLoading" 
        @onDelete="onDeleteLCARecords" 
      ></data-management-dialog>
      <Loader :loading="loading" :message="LoaderText"></Loader>
      <MessageSheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></MessageSheet>
    </v-card>
  </div>
</template>

<script>
import Vue from "vue";
import UploadFile from "@/components/documents/UploadFile.vue";
import { mapActions, mapState } from "vuex";
import Loader from "@/components/Loader.vue";
import { createUUID, formatBytes } from "@/utils/util";
import { fileIcons, MAX_UPLOAD_SIZE } from "@/utils/constant";
import MessageSheet from "@/components/MessageSheet.vue";
import LCAGridView from "./LCAGridView.vue";
import DataManagementDialog from "./DataManagementDialog.vue";

Vue.prototype.$eventHub = new Vue();
export default {
  name: "AgendaViewGrid",
  components: {
    MessageSheet,
    UploadFile,
    Loader,
    LCAGridView,
    DataManagementDialog
  },
  props: {
    gridHeight: { type: Number, default: window.innerHeight - 230 },
  },
  data() {
    return {
      isDataManagementDialogOpen: false,
      render: 0,
      companyTabCompanies: [],
      companyNames: [],
      paginatedResult: [],
      pageCount: 0,
      itemsPerPage: 1,
      page: 1,
      fiscalTermsList: [],
      isFileUploaded: false,
      isCompanyList: false,
      selectedFiscalTerms: [],
      selectedComparedTo: [],
      displayMessage: false,
      message: "",
      messageType: "",
      fileType: [],
      file_accept: ["text/plain", ".tsv", ""],
      valid: false,
      loading: false,
      fileIcons,
      uploadingFiles: [],
      uploadDialog: false,
      isOpen: false,
      selectedCompanies: [],
      updatingSelectedCompanies: [],
      companyList: [],
      isInvalidLCAFile: false,
      dataSource: [],
      wrapSettings: { wrapMode: "Content" },
    };
  },
  watch: {
    selectedCompanies(newCompanies) {
      this.updatingSelectedCompanies = newCompanies.map((item) => item["Company(Code)"])
      this.retrieveLCAData(
        this.selectedFiscalTerms,
        this.selectedComparedTo,
        this.updatingSelectedCompanies
      );
    },
    currentLCATab() {
      this.render++;
    },
  },
  computed: {
    ...mapState({
      lcaFiscalTerms: (state) => state.agenda.lcaFiscalTerms,
      lcaCompanies: (state) => state.agenda.lcaCompanies,
      lcaData: (state) => state.agenda.lcaData,
      currentLCATab: (state) => state.agenda.currentLCATab,
    }),
    getCompanyAccountData() {
      return this.lcaRes?.reduce((companyDetails, company) => {
        // Add company details
        if (!companyDetails[company["Company(Name)"]]) {
          companyDetails[company["Company(Name)"]] = [];
        }
        // Add accountData details for each company
        company.data.forEach((accountData, index) => {
          companyDetails[company["Company(Name)"]].push({
            companyName: company["Company(Name)"],
            companyCode: company["Company(Code)"],
            projectCode: company["Project(Code)"],
            projectName: company["Project(Name)"],
            companyId: company.id,
            accountCode: accountData["Account(Code)"],
            accountName: accountData["Account(Name)"],
            accountSortNumber: accountData["Account(Sort Number)"],
            parentBasicAmount: accountData["Parent Basis Amount"],
            amountInPreviousTerm: accountData["Amount in Previous Term"],
            previousTermDifference: accountData["Previous Term Difference"],
            previousTermRatio: accountData["Previous Term Ratio"],
            isRowSpan: Boolean(index),
            index: companyDetails[company["Company(Name)"]].length + 1,
          });
        });
        return companyDetails;
      }, []);
    },
    totalItems() {
      return this.getCompanyAccountData.length;
    },
    companyItems() {
      return this.getCompanyAccountData;
    },
    totalPages() {
      return Math.ceil(this.companyNames.length / this.itemsPerPage);
    },
    startItem() {
      return (this.page - 1) * this.itemsPerPage + 1;
    },
    endItem() {
      return Math.min(this.page * this.itemsPerPage, this.companyNames.length);
    },
    headers() {
      return [
        {
          text: "Company Details",
          align: "start",
          value: "companyCode",
          class: "header header-text",
          sortable: false,
        },
        {
          text: "Project Details",
          align: "start",
          value: "projectCode",
          class: "header header-text",
          sortable: false,
        },
        {
          text: "Account(Name)",
          value: "accountName",
          class: "header header-text",
          sortable: false,
        },
        {
          text: "Account(Code)",
          value: "accountCode",
          class: "header header-text",
          sortable: false,
        },
        {
          text: "Parent Basis Amount",
          value: "parentBasicAmount",
          class: "header header-text",
          sortable: false,
        },
        {
          text: "Account(Sort Number)",
          value: "accountSortNumber",
          class: "header header-text",
          sortable: false,
        },
        {
          text: "Amount in Previous Term",
          value: "amountInPreviousTerm",
          class: "header header-text",
          sortable: false,
        },
        {
          text: "Previous Term Difference",
          value: "previousTermDifference",
          class: "header header-text",
          sortable: false,
        },
        {
          text: "Previous Term Ratio",
          value: "previousTermRatio",
          class: "header header-text",
          sortable: false,
        },
      ];
    },
    errorCount() {
      let count = 0;
      for (const item of this.uploadingFiles) {
        if (this.checkStatus(item).status === false) {
          count++;
        }
      }
      return count;
    },
    allNodesSelected() {
      return (
        this.selectedCompanies.length > 0 &&
        this.companyList.length > 0 &&
        this.selectedCompanies.length === this.companyList.length
      );
    },
    label() {
      if (
        this.selectedCompanies.length > 0 &&
        this.selectedCompanies.length == 1
      ) {
        const m_types = Array.prototype.map
        .call(this.selectedCompanies, function (item) {
          return item["Company(Name)"];
        })
        .join(",");
        return m_types;
      } else if (this.allNodesSelected) {
        return this.$t("business.lblAllCompaniesSelected");
      } else if (this.selectedCompanies.length > 1) {
        return `${this.selectedCompanies.length} ${this.$t(
          "business.lblCompaniesSelected"
        )}`;
      }
      return this.$t("business.lblSelectCompanies");
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    lcaRes() {
      return this.lcaData;
    },
    updateBusinessPerformancePermission() {
      return this.$security.checkUserAccess("UpdateBusinessPerformance");
    },
    showDataManagementBtn() {
      return this.updateBusinessPerformancePermission && this.fiscalTermsList.length > 0;
    }
  },
  async mounted() {
    await this.getFiscalTerms();
  },
  methods: {
    ...mapActions({
      getLcaFiscalTerms: "agenda/getLcaFiscalTerms",
      getLCACompanies: "agenda/getLCACompanies",
      getLCAData: "agenda/getLCAData",
      createLCAData: "agenda/createLCAData",
    }),
    async getFiscalTerms(afterDelete) {
      try {
        this.loading = true;
        await this.getLcaFiscalTerms({ report_type: "lca-660" });
        this.fiscalTermsList = this.lcaFiscalTerms.sort((a,b) => b["Project(Code)"].localeCompare(a["Project(Code)"]));
        if(afterDelete) {
          this.selectedFiscalTerms = this.fiscalTermsList.length ? this.fiscalTermsList[0] : [];
          this.selectedComparedTo = this.fiscalTermsList.length ? this.fiscalTermsList[0] : [];
        } else {
          this.selectedFiscalTerms = this.fiscalTermsList.length ? this.fiscalTermsList[0] : [];
          this.selectedComparedTo = this.fiscalTermsList.length ? this.fiscalTermsList[0] : [];
          if(!this.isFileUploaded)
          {
            await this.selectPreviousYearProject()
          }
        }
        this.getCompanyList(this.selectedFiscalTerms)
      } catch (error) {
        this.loading = false;
      } finally {
        this.loading = false;
        this.$emit('renderTab', true)
        this.render++;
      }
    },
    async selectPreviousYearProject() {
      const currentCode = this.selectedFiscalTerms["Project(Code)"];

      const yearStr = currentCode.slice(3, 7);

      if (!/^\d{4}$/.test(yearStr)) {
        return;
      }
      
      const prevYear = parseInt(yearStr) - 1;
      const prevCode = currentCode.slice(0, 3) + prevYear + currentCode.slice(7);
      
      const match = this.fiscalTermsList.find(
        p => String(p["Project(Code)"]) === String(prevCode)
      );

      if (match) {
        this.selectedComparedTo = match;
      } else {
        this.selectedComparedTo = []
      }
      if(!this.isCompanyList){
        await this.getCompanyList(this.selectedFiscalTerms)
      }
      this.isFileUploaded = false
    },
    updateDataManagementDialog(value) {
      this.isDataManagementDialogOpen = value;
    },
    updateLoading(value) {
      this.loading = value;
    },
    async onDeleteLCARecords(value) {
      if(value) {
        this.showMessageSheet(
          this.$t("business.msgDeleteLCARecordsSuccessByCompany"),
          "success"
        );
        await this.getFiscalTerms(true);
      }
    },
    scrollToTop() {
      document.getElementById("row-1").scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    },
    prevPage() {
      this.page = this.page - 1;
      this.pagination(this.companyItems, this.itemsPerPage, this.page);
      setTimeout(() => {
        this.scrollToTop();
      }, 0);
    },
    nextPage() {
      this.page = this.page + 1;
      this.pagination(this.companyItems, this.itemsPerPage, this.page);
      setTimeout(() => {
        this.scrollToTop();
      }, 0);
    },
    changeItemsPerPage(updatedItemsPerPage) {
      this.page = 1;
      this.pagination(
        this.companyItems,
        updatedItemsPerPage > this.companyNames.length
          ? this.companyNames.length
          : updatedItemsPerPage,
        this.page
      );
      setTimeout(() => {
        this.scrollToTop();
      }, 0);
    },
    pagination(groupedData, pageSize, currentPage) {
      this.companyNames = Object.keys(groupedData);

      // Calculate start and end indexes for the current page
      const startIdx = (currentPage - 1) * pageSize;
      const endIdx = startIdx + pageSize;
      // Get the current page subset of company names
      const pageCompanyNames = this.companyNames.slice(startIdx, endIdx);
      // Prepare paginated result
      let resultArr = pageCompanyNames.reduce((result, companyName) => {
        result[companyName] = groupedData[companyName];
        return result;
      }, {});
      this.paginatedResult = Object.values(resultArr).flat();
    },
    getRowspan(item) {
      return this.paginatedResult.filter(
        (i) => i.companyName === item.companyName
      ).length;
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    checkStatus(file) {
      const maxSize = MAX_UPLOAD_SIZE ?? 0;
      let filesWithStatus = {
        filename: file.name,
      };
      if (!this.file_accept.includes(file.type)) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileErrorMsg", {
          filename: file.name,
        });
      } else if (file.size > maxSize) {
        filesWithStatus.status = false;
        filesWithStatus.message = this.$t("fileSizeErrorMsg", {
          maxsize: formatBytes(maxSize),
        });
      } else {
        filesWithStatus.status = true;
        filesWithStatus.message = "Success";
      }
      return filesWithStatus;
    },
    async changeFiscalTerm() {
      this.selectPreviousYearProject()
    },
    async getCompanyList(fiscalTerms){
      const payload = {
        project_code: fiscalTerms["Project(Code)"],
        previous_project_code: this.selectedComparedTo ? this.selectedComparedTo["Project(Code)"] : fiscalTerms["Project(Code)"]
      }
      await this.getLCACompanies(payload);
      this.companyList = this.lcaCompanies.length ? this.lcaCompanies.sort((a, b) => 
            a['Company(Name)']?.localeCompare(b['Company(Name)'])
      ) : [];
      this.selectedCompanies = this.lcaCompanies.length ? this.lcaCompanies : [];
      this.isCompanyList = false
    },
    async changeComparedTo(newComparedTo) {
      const payload = {
        project_code: this.selectedFiscalTerms["Project(Code)"],
        previous_project_code: newComparedTo["Project(Code)"]
      }
      await this.getLCACompanies(payload);
      this.companyList = this.lcaCompanies.length ? this.lcaCompanies.sort((a, b) => 
            a['Company(Name)']?.localeCompare(b['Company(Name)'])
      ) : [];
      this.selectedCompanies = this.lcaCompanies.length ? this.lcaCompanies : [];
    },
    async retrieveLCAData(
      selectedFiscalTerms,
      selectedComparedTo,
      selectedCompanies
    ) {
      try {
        this.isFileUploaded = true
        this.loading = true;
        this.isOpen = false;
        let data = {
          project_code: selectedFiscalTerms["Project(Code)"],
          project_name: selectedFiscalTerms["Project(Name)"],
          previous_project_code: selectedComparedTo["Project(Code)"],
          previous_project_name: selectedComparedTo["Project(Name)"],
          company_codes: JSON.stringify(selectedCompanies),
        };
        await this.getLCAData(data);
        this.render++;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    closeUploadFiles() {
      this.uploadingFiles = [];
      this.uploadDialog = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    removeUploadingFile(index) {
      this.uploadingFiles.splice(index, 1);
    },
    addUploadingFiles(files) {
      files = Array.from(files);

      this.uploadingFiles.push(...files);
    },
    selectLCAReport() {
      this.uploadDialog = true;
    },
    async uploadLCAReport() {
      if (this.$refs.form.validate()) {
        this.uploadingFiles.forEach((item) => {
          this.fileType.push(
            item.type ||
            item.name.split(".").pop() === "tsv"
              ? "text/tab-separated-values"
              : "")
        })
        this.loading = true;
      }
      try {
        for (let index = 0; index < this.uploadingFiles.length; index++) {
          const item = this.uploadingFiles[index];
          const formData = new FormData();

          formData.append("file", item);
          formData.append("filename", item.name);
          formData.append("content_type", this.fileType[index]);
          formData.append("documentId", createUUID());
          formData.append("document_type", "lca-660");

          await this.createLCAData(formData);
          this.showMessageSheet(
            this.$t("documents.DocUploadSuccessMessage"),
            "success"
          );
        }
        this.closeUploadFiles();
        await this.getFiscalTerms();
      } catch (error) {
        throw error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.border-right {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}

.top-align {
  vertical-align: top;
  padding-top: 5px !important;
}

.v-toolbar /deep/ .v-toolbar__content {
  color: var(--v-darkCharcoal-base);
  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
}

::v-deep .disablegrid {
  pointer-events: none;
  opacity: 0.9;
}

.fiscal-terms-selection /deep/ .v-text-field__details,
.comparedTo-selection /deep/ .v-text-field__details {
  display: none !important;
}

.fiscal-terms-selection /deep/ .v-input__slot,
.comparedTo-selection /deep/ .v-input__slot {
  margin-bottom: 0px;
  min-height: 45px;
  max-height: 45px;
  background: #fafafa;
  border-radius: 4px;
}

.fiscal-terms-selection /deep/ fieldset,
.comparedTo-selection /deep/ fieldset {
  border-color: rgba(0, 0, 0, 0.12);
}
</style>
